<h1 mat-dialog-title>{{cls.getSingle$('Customer') | async}} anlegen</h1>
<mat-dialog-content>
    <app-new-customer-main #mainComponent [DefaultValues]="data?.defaultValues" [PreventNewPersonDialog]="data?.preventNewPersonDialog"></app-new-customer-main>
</mat-dialog-content>
<mat-dialog-actions>
  <button app-button Inverted Color="cancel" type="button" (click)="closeDialog()">Abbrechen</button>
  <button app-button Color="green" [Disabled]="mainComponent.AreFormsInvalid$ | async" (click)="Submit()" [IsLoading]="ls.IsLoading$ | async">Speichern</button>
</mat-dialog-actions>
